import {instance} from "../lib/request";

function list(options) {
    return instance.get('/api/web/photo/list', {
        params: options,
    });
}

function get(options) {
    return instance.get('/api/web/photo/get', {
        params: options,
    });
}

export default {
    list, get
}
